import { combineReducers } from "redux";
import { fileManagerReducer } from "./DocumentsList/FileManager/__redux/reducers";

export const documentsReducer = combineReducers({
	fileManager: fileManagerReducer,
});
